import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Philosophy: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="philosophy" className="philosophy">
      <div className="philosophy-content">
        <h2>{t('philosophy.title')}</h2>
        <div className="philosophy-grid">
          <div className="philosophy-card">
            <h3>{t('philosophy.personalizedTraining.title')}</h3>
            <p>{t('philosophy.personalizedTraining.description')}</p>
          </div>
          <div className="philosophy-card">
            <h3>{t('philosophy.balancedLifestyle.title')}</h3>
            <p>{t('philosophy.balancedLifestyle.description')}</p>
          </div>
          <div className="philosophy-card">
            <h3>{t('philosophy.scienceBased.title')}</h3>
            <p>{t('philosophy.scienceBased.description')}</p>
          </div>
          <div className="philosophy-card">
            <h3>{t('philosophy.longTermSuccess.title')}</h3>
            <p>{t('philosophy.longTermSuccess.description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy; 